import {
  AddDistributorSellInvoiceUrl,
  GetCompanyWiseInventoryDataUrl,
  GetProductWiseinventoryDataUrl,
  SendOtpToGiftRecieverUrl,
  VerifyOtpToGiftRecieverUrl,
  UploadGiftImageUrl,
  SendOtpToMasonGiftRecieverUrl,
  UpdateGiftStatusUrl,
  registerNotificationTokenUrl,
  deleteNotificationTokenUrl,
  GetNotificationPaginUrl,
  getUserInventoryTransactionsStpInfoUrl,
} from '../api';
import { axios } from '../../../utils/settings';
import {
  getTokenHeader,
  getToken,
  getTokenHeaderFile,
} from '../../auth/action';


export const GetCompanyWiseInventoryData = async (company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetCompanyWiseInventoryDataUrl()}?company_esi_id=${company_esi_id}`, getTokenHeaderFile(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GetProductWiseinventoryData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetProductWiseinventoryDataUrl()}`, {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};


export const AddDistributorSellInvoice = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(`${AddDistributorSellInvoiceUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getUserInventoryTransactionsStpInfoAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        getUserInventoryTransactionsStpInfoUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
// Gifts Url  
export const SendOtpToGiftReciever = (transactionId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${SendOtpToGiftRecieverUrl()}?transaction_id=${transactionId}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const VerifyOtpToGiftReciever = (transactionId, otp) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${VerifyOtpToGiftRecieverUrl()}?transaction_id=${transactionId}&otp=${otp}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const UploadGiftImage = async (transactionId, data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${UploadGiftImageUrl()}?transaction_id=${transactionId}`, data, {
        headers: {
          Authorization: 'Bearer ' + token,
          Accept: 'application/json',
          'content-type': 'multipart/form-data;',
        },
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendOtpToMasonGiftReciever = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${SendOtpToMasonGiftRecieverUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const UpdateGiftStatus = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${UpdateGiftStatusUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

//Notification
export const registerNotificationToken = async (userToken, data) => {
  console.log('userToken', userToken);
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(
        `${registerNotificationTokenUrl(userToken)}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const deleteRegisterNotificationToken = async (userToken, data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .delete(`${deleteNotificationTokenUrl(userToken)}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

// paginated notifications
export const GetNotificationsPaginData = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(GetNotificationPaginUrl(), {
        ...getTokenHeaderFile(token),
        params: data,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
